import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, salesHomeRoute } from 'config/Api.Config';
import useContractConsent from './ContractConsent.Hooks';
import ContractConsentList from './sections/ContractConsent.List';
import ContractConsentResendConsent from './sections/ContractConsent.ResendConsent';
import ContractConsentManuallyAcceptConsent from './sections/ContractConsent.ManuallyAcceptConsent';

export const contractConsentIndexRoute = salesHomeRoute + '/consents/:action?/:id?';

export default function ContractConsentIndex() {
  const contractConsentsHook = useContractConsent();

  if (!contractConsentsHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={contractConsentsHook}
        render={({ views }) => (
          <>
            {views.resendConsent && <ContractConsentResendConsent />}
            {views.manuallyAcceptConsent && <ContractConsentManuallyAcceptConsent />}
            <ContractConsentList />
          </>
        )}
      />
    </>
  );
}
